import airports from "../assets/json/airports.json";
import { AIRCRAFT_ENGINE_TYPES, DATA_TYPES, PAYMENT_STATUS } from "./constants";

export const getInvoicingFBOType = (type) => {
  switch (type) {
    case "fuel-royalty":
      return "FUEL_ROYALTY";
    case "airport-based-operators":
      return "LAND_LEASE";
    default:
      return "LANDING_FEE";
  }
};

export const getInvoiceStatus = (type) => {
  switch (type) {
    case 0:
      return "CREATED, PARTIAL_PAYMENT";
    case 1:
      return "PAID, SETTLED,VERIFICATION_PENDING";
    case 2:
      return "OVERDUE";
    default:
      return "CREATED";
  }
};

export const formatDateToISOString = (date) => {
  if (!date) return null;
  return new Date(date).toISOString();
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const getAirportData = (data, id) => {
  const airportData = data?.find((airport) => airport?.id === id);
  if (!airportData) {
    return airports.find((airport) => airport?.id === id) || null;
  }
  return airportData;
};

export const handleAircraftType = (item) => {
  if (item && item !== "") {
    if (item === AIRCRAFT_ENGINE_TYPES.PISTON) {
      return "PROP (PISTON)";
    } else if (item === AIRCRAFT_ENGINE_TYPES.TURBOPROP) {
      return "PROP (TURBOPROP)";
    } else if (item === AIRCRAFT_ENGINE_TYPES.TURBOSHAFT) {
      return "PROP (TURBOSHAFT)";
    } else {
      return item;
    }
  }
  return "---";
};

export const formatToTwoDecimal = (number) => {
  if (typeof number !== DATA_TYPES.NUMBER) {
    return "0.00";
  }
  return number.toFixed(2);
};

export const handleEmptyValue = (item) => {
  if (item && item !== "") {
    return item;
  }
  return "---";
};

export const getPaymentFBOType = (type) => {
  switch (type) {
    case "LANDING_FEE":
      return "Landing Fee";
    case "FUEL_ROYALTY":
      return "Fuel Royalty";
    case "LAND_LEASE":
      return "Airport Based Operators - ABOs";
    default:
      return "---";
  }
};

export const getPaymentMethodDisplay = (paymentMethod) => {
  const PAYMENT_METHOD = {
    WIRE_TRANSFER: "Wire Transfer",
    CREDIT_CARD: "Credit Card",
  };
  return PAYMENT_METHOD[paymentMethod] || "---";
};

export const getPaymentStatus = (remainingAmount) => {
  if (remainingAmount === 0) {
    return PAYMENT_STATUS.PAID;
  } else if (remainingAmount > 0) {
    return PAYMENT_STATUS.PARTIAL_PAID;
  } else {
    return PAYMENT_STATUS.OVERPAID;
  }
};

export const formatNumber = (number) => {
  if (typeof number !== DATA_TYPES.NUMBER) {
    return "0.00";
  }
  return number.toFixed(2);
};